import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import './App.css';
import authSetting from './auth/auth-setting';
import Home from './components/home';

Amplify.configure(authSetting);

const App = () => {
  return (
    <Authenticator loginMechanisms={['email']} hideSignUp>
      <Home />
    </Authenticator>
  );
};

export default App;
